/*************************************************************************
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import Icon from "@react/react-spectrum/Icon";
import PropTypes from "prop-types";

const CustomIcon = props => {
  const IconCls = props.url;
  return (
    <Icon size={props.size} className={props.className}>
      <IconCls size={props.size} className={props.svgClassName} />
    </Icon>
  );
};

export default CustomIcon;

CustomIcon.propTypes = {
  url: PropTypes.element.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  svgClassName: PropTypes.string
};

CustomIcon.defaultProps = {
  className: null,
  size: "S",
  svgClassName: null
};
